/**
 * Configuración global de endpoints
 * Se adjuntan a la API_BASE_SRC
 * Ej: API_BASE_SRC + '/' + endpoints.EJEMPLO
 */
export const CONSULTAR_OFERTA = "post";
export const CONSULTAR_EVALUACION = "consultaEvaluacion";
export const ENVIAR_MAIL_SIMULACION = "enviarMailSimulacion";
